import { render, staticRenderFns } from "./MarketingPageShell.vue?vue&type=template&id=649bd07a&scoped=true&"
import script from "./MarketingPageShell.vue?vue&type=script&lang=js&"
export * from "./MarketingPageShell.vue?vue&type=script&lang=js&"
import style0 from "./MarketingPageShell.vue?vue&type=style&index=0&id=649bd07a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "649bd07a",
  null
  
)

export default component.exports